import * as CommonUtilities from "./../../../common/utils/CommonUtils.js";

export default function Location(props){    

    // Catering Check
    let openClosedBadge, openNowText;
    if (CommonUtilities.StaticFields.PickupMenuType === 'webordering') {
        openClosedBadge = props.data.isAllowS8WebCateringOrder ? <div className="badge text-bg-success float-right">Open</div> : <div className="badge text-bg-secondary float-right">Closed</div>
        openNowText = props.data.isAllowS8WebCateringOrder ? <b className="text-success">Order Now</b> : <></>
    } else {
        openClosedBadge = props.data.isAllowOnlineOrder ? <div className="badge text-bg-success float-right">Open</div> : <div className="badge text-bg-secondary float-right">Closed</div>
        openNowText = props.data.isAllowOnlineOrder ? <b className="text-success">Order Now</b> : <></>
    }

    return (
        <div>
            <hr className="text-body-tertiary"/>
            {/* style={props.currentLocation.LocationID == props.data.locationNumber ? {cursor: "default"} : {cursor: "pointer"}} */}
            <div className="d-flex justify-content-between" onClick={props.currentLocation.LocationID == props.data.locationNumber ? null : props.handleSelectLocation} data-locnum={props.data.locationNumber} style={props.currentLocation.LocationID == props.data.locationNumber ? {cursor: "default"} : {cursor: "pointer"}}>
            {/* <div className="d-flex justify-content-between"> */}
                <div>
                    <b>{props.data.locationName}</b><br />
                    <span>{props.data.locationAddress1}</span><br />
                    {props.data.locationAddress2 && <><span>{props.data.locationAddress2}</span><br /></>}
                    <span>{props.data.locationSuburb} {props.data.locationState} {props.data.locationPostCode}</span><br />
                    {openNowText}
                </div>
                <div className="float-right d-flex flex-column align-items-end">
                    {openClosedBadge}
                    {/* <span>{props.data.distance}km</span> */}
                    {props.currentLocation.LocationID == props.data.locationNumber ? 
                        <button type="radio" className="btn btn-success mt-auto" name="locationGroup" style={{cursor: "default", minWidth: "109px"}} value={props.data.locationNumber}>Selected Store</button>
                        : <button type="radio" className="btn btn-light mt-auto" name="locationGroup" style={{minWidth: "109px"}} onClick={props.handleSelectLocation} value={props.data.locationNumber} data-locnum={props.data.locationNumber}>Select Store</button>}
                </div>
            </div> 

        </div>
    )
}